import { useEffect, useState } from "react";
import Button from "./Button";
import { numFormat } from "../utils/utils";

export default function DetailpeeView(props) {

    const { style = {}, detailpeeJson = null } = props;

    const [detailpeeList, setdetailpeeList] = useState([])
    const [tabIndex, settabIndex] = useState(0);

    // 데이터에 대한 선택 필드 설정
    const setDatas = (parseData) => {
        let tabData = parseData.find(v => v?.key === "standard_tab");
        if (tabData)
            settabIndex(tabData?.values);
        else
            settabIndex(0);
    }

    useEffect(() => {
        if (detailpeeJson) {
            let parseData = []
            try {
                parseData = JSON.parse(detailpeeJson);
                setDatas(parseData);
            } catch (error) { }
            setdetailpeeList(parseData)
            console.log("parseData!!!!", parseData)
        }
    }, [detailpeeJson])

    return <div style={{
        display: "flex",
        flexDirection: "column",
        gap: 10,
        padding: 10,
        borderRadius: 8,
        border: "1px solid #DDD",
        ...style
    }}>
        <p style={{ fontWeight: 700 }}>
            관리비 세부내역
        </p>
        {/* <div
            style={{ display: 'flex', gap: 10 }}
        >
            {[
                { tabs: 0, labels: '정액관리비' },
                { tabs: 1, labels: '기타부과' },
                { tabs: 2, labels: '확인불가' },
                { tabs: 3, labels: '정액관리비2' },
            ]?.map((x, i) => {
                return (
                    <Button
                        className={tabIndex === x?.tabs ? 'linenormalbuttonbold' : 'linenormalbutton_disable'}
                        styles={{
                            height: 40, fontSize: 12,
                            color: tabIndex === x?.tabs ? '#6164A5' : '#999',
                            width: 80
                        }}
                        buttonTxt={x?.labels}
                        onPress={() => {
                            settabIndex(x?.tabs);
                        }}
                    />
                );
            })}
        </div> */}

        {
            [0, 1, 3].includes(tabIndex) ?
            <div>
                <InfoBox
                    style={{ borderTop: "1px solid #DDD" }}
                    title={"부과 기준"}
                    value={
                        detailpeeList.find(v => v?.key === "standard_values")?.values + " " +
                        (detailpeeList.find(v => v?.key === "standard_values")?.radios?.find(v => v.values === detailpeeList.find(v => v?.key === "standard_values")?.values)?.textareas ?
                            detailpeeList.find(v => v?.key === "standard_values")?.radios?.find(v => v.values === detailpeeList.find(v => v?.key === "standard_values")?.values)?.textareasvalue :
                            "")
                    }
                />
            </div>:
            "-"
        }

        {tabIndex == 0 && <div>
            <p style={{ fontWeight: 700, marginBottom: 4 }}>정액관리비</p>
            {detailpeeList?.find(item => item?.key === 'standard_tabs0JSON')?.values?.map((x, i) => {
                if (i > 6 && !x?.pricetype) {
                    return <></>
                }

                if (i == 7) {
                    return <>
                        <InfoBox
                            title={x?.labels}
                            value={`${x?.pricetype}${x?.pricetype === "정액" ? " / " + (numFormat(x?.prices) || 0) + "원" : ""}`}
                        />
                        <InfoBox
                            title={"기타관리비내용"}
                            value={detailpeeList?.find(item => item?.key === 'standard_tabs0JSON')?.values[8]?.prices || "-"}
                        />
                    </>
                }

                return <InfoBox
                    style={i === 0 ? { borderTop: "1px solid #DDD" } : {}}
                    title={x?.labels}
                    value={`${x?.pricetype}${(x?.pricetype === "정액" || i === 0)? " / " + (numFormat(x?.prices) || 0) + "원" : ""}`}
                />
            })}
        </div>}
        {(tabIndex == 1 || tabIndex == 3) && <div>
            <p style={{ fontWeight: 700, marginBottom: 4 }}>
                {tabIndex == 1 ? "기타부과" : "정액관리비2"}
            </p>
            <InfoBox
                style={{ borderTop: "1px solid #DDD" }}
                title={"부과 사유"}
                value={detailpeeList?.find(item => item?.key === 'standard_reason_values')?.values}
                subValue={
                    tabIndex == 3 ? 
                    detailpeeList?.find(item => item?.key === 'standard_reason_values')?.radios?.find(v => v.values === '기타-직접입력')?.textareas ?
                    ""+detailpeeList?.find(item => item?.key === 'standard_reason_values')?.radios?.find(v => v.values === '기타-직접입력')?.textareasvalue :
                    "":
                    (detailpeeList?.find(item => item?.key === 'standard_reason_values')?.radios?.find(v => v.values === detailpeeList?.find(item => item?.key === 'standard_reason_values')?.values)?.textareas ?
                    detailpeeList?.find(item => item?.key === 'standard_reason_values')?.radios?.find(v => v.values === detailpeeList?.find(item => item?.key === 'standard_reason_values')?.values)?.textareasvalue :
                    "")
                }
            />
            <InfoBox
                title={"금액(단위:원)"}
                value={numFormat(detailpeeList?.find(item => item?.key === 'standard_reason_price')?.values || 0) + "원"}
            />
            <InfoBox
                title={"포함목록"}
                value={detailpeeList?.find(item => item?.key === 'standard_reason_sel')?.values?.map(v => v?.names)?.toString()}
            />
        </div>}

        {tabIndex == 2 && <div>
            <p style={{ fontWeight: 700, marginBottom: 4 }}>확인불가</p>
            <InfoBox
                style={{ borderTop: "1px solid #DDD" }}
                title={"확인불가사유"}
                value={detailpeeList?.find(item => item?.key === 'standard_no_reason_values')?.values}
                subValue={
                    detailpeeList?.find(item => item?.key === 'standard_no_reason_values')?.radios?.find(v => v.values === detailpeeList?.find(item => item?.key === 'standard_no_reason_values')?.values)?.textareas ?
                        detailpeeList?.find(item => item?.key === 'standard_no_reason_values')?.radios?.find(v => v.values === detailpeeList?.find(item => item?.key === 'standard_no_reason_values')?.values)?.textareasvalue :
                        ""
                }
            />
        </div>}

        {![0, 1, 2, 3].includes(tabIndex) && <div>
            {/* 관리비 데이터 없음 */}
            -
        </div>}
    </div>
}


// 내부 사용 컴포넌트 ++++++++++++++++++++

const InfoBox = (props) => {
    const {
        style = {},
        title = "",
        value = "",
        subValue = ""
    } = props;
    return <div style={{
        display: "flex",
        width: "100%",
        minHeight: 33,
        borderBottom: "1px solid #DDD",
        ...style
    }}>
        <div style={{
            display: "flex",
            alignItems: "center",
            width: 100,
            flexShrink: 0,
            padding: 4,
            background: "#F1F1F1"
        }}>{title}</div>
        <div style={{
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
            padding: 5
        }}>
            <p>{value}</p>
            {subValue && <p>{subValue}</p>}
        </div>
    </div>
}

// 내부 사용 컴포넌트 --------------------